// extracted by mini-css-extract-plugin
export default {"price_version_note":"nBmnDIcXdQUVgZMM3cZn","priceVersionNote":"nBmnDIcXdQUVgZMM3cZn"};